/**
 * example of this error would be if the user tries to add a break stop from the chart for a trade plan that has no position.
 * we would stop the action, saying you cant set the stop for a trade plan with no position.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645465317063,
	"notificationDetails": {"errorType":"USER_ACTION","notificationType":"ERROR","userAction":"ADD_BREAK_PRICE_STOP","userActionDetails":{"addPriceSymbol":"XYZ","price":22.0,"userAction":"ADD_BREAK_PRICE_STOP"},"TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "NO_POSITION",
	"statusDetails": {"symbol":"XYZ"},
	"date": "2022-02-21T12:41:58.065-0500",
	"timestamp": "1645465318065"
}

 * @param {*} statusDetails 
 * @returns object with field:
 * 1) symbol: this field can often be null, but just trying to give information of the symbol this status is relevant to. 
 */
export function noPositionParser(statusDetails) {
  const parsedObj = {
    symbol: null,
  };
  if (statusDetails) {
    parsedObj.symbol = statusDetails.symbol ?? null;
  }

  return parsedObj;
}
